import State from './State';

export default class Address {
    id: number;
    addressLine1: string | undefined;
    addressLine2?: string | undefined;
    state: State | undefined;
    stateId?: number | undefined;
    city: string | undefined;
    zipCode: string | undefined;

    constructor() {
        this.state = new State();
    }
}



// WEBPACK FOOTER //
// ./src/models/Address.ts